<script>
  import Vue from 'vue'
  import api from '../api'
  import swal from 'sweetalert'
  import form from '../mixins/form'

  export default {

    mixins: [form],

    created () {
      this.fetchClients()
    },
    
    data () {
      return {
        clients: []
      }
    },

    methods: {
      async fetchClients () {
        let response = await api.apios.get('/api/clients')

        this.clients = response.data

        this.$emit('ready')
      }
    }
  }
</script>

<template>
  <form @submit.prevent="submit" novalidate>
    <div class="field">
      <label class="label">Client</label>
      <p class="control">
        <span class="select">
          <select v-model="form.client_id" name="client_id" v-validate="'required'" required>
            <option value="" />
            <option v-for="client in clients" :value="client.id">
              {{ client.email }}
            </option>
          </select>
        </span>
      </p>
      <p v-show="errors.has('client_id')" class="help is-danger">{{ errors.first('client_id') }}</p>
    </div>
    
    <div class="field">
      <label class="label">Address</label>
      <p class="control">
        <input v-model="form.name" name="name" v-validate="'required'" required class="input" type="text" placeholder="Address">
      </p>
      <p v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</p>
    </div>    

    <div class="field is-grouped">
      <p class="control">
        <button class="button is-primary" :class="{ 'is-loading': loading }">Submit</button>
      </p>
      <p class="control">
        <router-link to="/" class="button is-link">Cancel</router-link>
      </p>
    </div>

  </form>
</template>